const PostClose = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none">
            <path
                fill="#2962FF"
                transform="translate(12 12) scale(0.8) translate(-12 -12)"
                d="M12.34 2.02C6.59 1.82 2 6.42 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.96"
            />
        </svg>
    )
}
export default PostClose
